/*global VeloxGridController*/

var listingController = new VeloxGridController("customer", {
        directory: "views/listing",
        name: "listingGrid",
        route: "listing",
        canCreate: false, 
        joinFetch : [
            { otherTable: "pool", type: "2one"},
            { otherTable: "spa", type: "2one"},
        ]
    }
);


module.exports = listingController ;